<script setup lang="ts">
// #719 観点B: モバイルナビ背景に敷くエリアのマップ画像。
import islandMapBg from '@/assets/images/map/AreaMap_CrystalWaveIsland.webp'

const runtimeConfig = useRuntimeConfig()

const { isMobile } = useIsMobile()

useSeoMeta({
  title: 'クリスタルウェーブ島 | Code & Magic',
  description: 'エンコーディア南西部にある島です。',
  ogTitle: 'クリスタルウェーブ島 | Code & Magic',
  ogDescription: 'エンコーディア南西部にある島です。',
  ogImage: `${runtimeConfig.public.serviceDomain}/images/ogPlayMakeShare_wLogo.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  middleware: ['authenticated', 'confirm-game-state'],
  layout: false,
  usePageReady: true,
})

const { finishLoading } = usePageReady()

onMounted(async () => {
  await finishLoading()
})
</script>

<template>
  <NuxtLayout :name="isMobile ? 'mobile-nav' : 'centering43'">
    <SceneMap
      scene-id="wld_crystalWaveIsland"
      :mobile="isMobile"
      :mobile-background="islandMapBg"
    >
      <template #map>
        <v-img
          src="@/assets/images/map/AreaMap_CrystalWaveIsland.webp"
          width="100%"
          height="auto"
          lazy-src="@/assets/images/map/LazyAreaMap_CrystalWaveIsland.png"
          :transition="false"
        />
        <svg
          class="map-area"
          width="100%"
          height="100%"
          viewBox="0 0 2048 1536"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
        >
          <path
            data-scene-id="cwi_whiteCave"
            d="M692.481,600.599c42.868,-11.54 97.375,-0.872 127.238,8.858c28.006,9.126 56.069,34.662 72.679,53.956c14.342,16.66 21.643,38.437 28.186,58.183c6.533,19.716 5.906,59.959 -11.878,81.434c-10.74,12.969 -68.491,29.154 -96.234,32.114c-23.315,2.488 -117.531,-0.571 -153.008,-22.146c-48.883,-29.727 -65.674,-37.943 -73.082,-75.85c-8.715,-44.598 0.902,-63.782 21.341,-86.217c22.414,-24.604 39.997,-38.282 84.758,-50.332Z"
            class="scene"
          />
          <path
            data-scene-id="cwi_blueCrystal"
            d="M142.054,397.863c7.975,-17.973 33.555,-41.02 41.071,-59.19c9.798,-23.689 7.255,-69.146 26.575,-92.409c15.603,-18.787 54.912,-24.596 84.356,-18.522c23.331,4.813 62.181,38.48 73.484,56.975c16.92,27.686 25.568,85.832 27.582,107.307c2.045,21.818 -10.848,95.04 -28.387,108.716c-28.388,22.137 -98.263,12.671 -136.499,7.65c-41.191,-5.409 -57.244,-12.415 -75.699,-29.192c-20.383,-18.53 -23.295,-56.968 -12.482,-81.336Z"
            class="scene"
          />
          <path
            data-scene-id="cwi_redCrystal"
            d="M1709.985,1173.977c13.892,-38.151 3.792,-89.355 27.783,-109.32c23.991,-19.965 73.954,-36.205 100.462,-31.004c25.13,4.931 56.702,23.571 71.471,44.493c16.106,22.817 28.052,65.901 27.38,101.469c-0.545,28.9 4.494,86.016 -9.06,108.112c-15.433,25.16 -47.982,43.399 -80.732,46.708c-33.997,3.434 -70.095,0.268 -101.469,-9.462c-31.373,-9.731 -72.142,-20.435 -76.303,-53.352c-3.989,-31.561 28.633,-65.144 40.467,-97.643Z"
            class="scene"
          />
        </svg>
      </template>
    </SceneMap>
  </NuxtLayout>
</template>
